module.exports = __webpack_public_path__ + "static/media/ic-arrow-3.6c476212.svg";